import { render } from "./CalculadoraComponent.vue?vue&type=template&id=fbbcf174"
import script from "./CalculadoraComponent.vue?vue&type=script&lang=js"
export * from "./CalculadoraComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/mac2/Herd/mix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__